import ServiceCard from '@/components/common/cards/service-card/ServiceCard';
import BookingDatePickerFormBody from '@/components/common/forms/booking-datepicker-form-body/BookingDatePickerFormBody';
import ParticipantsDataFormBody from '@/components/common/forms/participants-data-form-body/ParticipantsDataFormBody';
import NewBookingSummaryModal from '@/components/modals/new-booking-summary-modal/NewBookingSummaryModal';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';
import { useFormLandingRental } from '@/hooks/business-logic/nb-landing/useFormLandingRental';
import useMixPanel from '@/hooks/useMixPanel';
import { TOrganizationFAQ } from '@/services/api/organization-api';
import { Service } from '@/services/api/services-api';
import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import PaymentStep from '../payment-step/PaymentStep';
import { TiptapViewer } from '@/components/common/tiptap-viewer/TiptapViewer';

type Props = {
  organization: TOrganizationFAQ;
  disabledDescription?: boolean;
  service: Service;
};

const NBLandingByDivisions = ({
  organization,
  disabledDescription,
  service
}: Props) => {
  const Mixpanel = useMixPanel();
  const { t } = useTranslation(['newBooking', 'common']);
  const {
    form,
    fields,
    userData,
    isPendingSale,
    isOpenSummaryModal,
    isSaleCreated,
    onSubmit,
    setIsOpenSummaryModal,
    addParticipant,
    removeParticipant
  } = useFormLandingRental({
    service,
    organization
  });

  const isTiptapViewer = service.landing_page_content;

  if (!service) {
    return null;
  }

  if (isSaleCreated) {
    return <PaymentStep organization={organization} />;
  }

  return (
    <>
      {isOpenSummaryModal && (
        <NewBookingSummaryModal
          user={userData}
          open={isOpenSummaryModal}
          onOpenChange={setIsOpenSummaryModal}
          organization={organization}
          isPending={isPendingSale}
          onSubmit={onSubmit}
        />
      )}
      {isTiptapViewer ? (
        <TiptapViewer
          content={service.landing_page_content}
          className="prose prose-lg max-w-none"
        />
      ) : (
        <ServiceCard service={service} organization={organization} />
      )}
      <Form {...form}>
        <form>
          {service && (
            <div className="flex flex-col gap-10">
              <BookingDatePickerFormBody
                form={form}
                organization={organization}
                serviceId={service.id}
                isLanding
              />
              <ParticipantsDataFormBody
                form={form}
                service={service}
                fields={fields}
                organization={organization}
                isLanding
                addParticipant={addParticipant}
                removeParticipant={removeParticipant}
              />
              <Button
                type="button"
                className="w-full"
                onClick={() => {
                  Mixpanel.track('press continue button', {
                    screen: 'New Booking'
                  });
                  setIsOpenSummaryModal(true);
                }}
                disabled={isPendingSale}
              >
                {isPendingSale ? (
                  <Loader className="mr-2 h-4 w-4 animate-spin" />
                ) : (
                  t('stepParticipants.form.continue')
                )}
              </Button>
            </div>
          )}
        </form>
      </Form>
    </>
  );
};

export default NBLandingByDivisions;
